import { render, staticRenderFns } from "./UploadedImage.vue?vue&type=template&id=fb0b4e4c&scoped=true&"
import script from "./UploadedImage.vue?vue&type=script&lang=js&"
export * from "./UploadedImage.vue?vue&type=script&lang=js&"
import style0 from "./UploadedImage.vue?vue&type=style&index=0&id=fb0b4e4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0b4e4c",
  null
  
)

export default component.exports